export interface BrandMockInterface {
  royal: string
  celebrity: string
}

export type ObjectBrandMockDictionary = keyof typeof BrandMockDictionary;

export const BrandMockDictionary: BrandMockInterface = {
  royal: 'R',
  celebrity: 'C'
}
